export const menu = [{ name: 'reports', label: 'Reports' }];
